<template>
  <div class="main-body">
    <div class="header">结算记录</div>
    <div class="out">

      <div class="search2">

        <div style="float: right">

          <el-select size="mini" v-model="businessCode" :clearable="true"
                     placeholder="请选择商家" style="margin-right:5px">
            <el-option
                v-for="item in arr_business"
                :key="item.businessCode"
                :label="item.businessName"
                :value="item.businessCode">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" :height="th"
                v-loading="loading" ref="table" border>

        <el-table-column prop="businessName" label="商家" width="200" fixed></el-table-column>


        <el-table-column prop="orderCount" label="总订单数" width="130"></el-table-column>
        <el-table-column prop="orderMoney" label="总金额" width="130"></el-table-column>

        <el-table-column prop="startTime" :formatter="timefilter" width="100" label="开始时间"></el-table-column>
        <el-table-column prop="endTime" :formatter="timefilter" width="100" label="结束时间"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" width="100" label="生成时间"></el-table-column>


        <el-table-column label="结算状态" >
          <template slot-scope="scope">
            <div v-if="scope.row.isSettlement ==0 ">待结算</div>
            <div v-if="scope.row.isSettlement ==1 ">已结算</div>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

  </div>
</template>

<script>

import {timeStr, timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Page",
  data() {
    return {

      loading: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,


      imgUrl: this.$imgUrl,
      th: this.$store.state.tableHeight,


      arr_business:[],
      businessCode:'',

    }
  },
  components: {

  },
  created() {
    this.init();

  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
      this.$nextTick(()=>{
        this.$refs.table.doLayout()
      })
    },
  },
  methods: {

    init() {

      this.getBusiness();
      this.getList();
    },

    getBusiness(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/ListForGov",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.arr_business = response.data.data;

        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },





    timefilter(row, column, cellValue) {
      if (cellValue) {
        return timefilters(cellValue).substring(0,10)
      }
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch) {

      if(isSearch)this.currentPage=1

      var _this=this

      this.loading=true

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),

        pageIndex:this.currentPage,
        pageSize:this.pageSize,

        businessCode:this.businessCode,

      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Total/PageByGovBusinessSettlement",
        data: data
      }).then((response) => {

        this.loading = false;

        if (response.data.error === 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;

          this.$nextTick(()=>{
            this.$refs.table.doLayout()
          })

        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }

      }).catch(function (error) {
        _this.loading = false;
        console.log(error);
      });

    },





  }
}
</script>


<style lang="scss" scoped>


</style>
